module.exports = __webpack_public_path__ + "static/hire-e175d26484a0b2c91c1af3daed82772b.svg";